

import apiWorker from '../apiWorker'

const credit_events = {
    check : (contact_id, type)  => apiWorker('get', `/v1/billing/credit_events/check/${contact_id}/${type}`),
}

export default credit_events;
